import { atom, useAtom } from 'jotai';

import { stack } from '@flipster/styled-system/patterns';

import { TvPriceTypeStorageKey } from '../misc/constants';
import { Button, CheckItem } from './button';
import { Dropdown } from './dropdown';

const priceTypeAtom = atom<PriceTypes | null>(null);
priceTypeAtom.debugLabel = 'priceTypeAtom';
export const persistentPriceTypeAtom = atom(
  (get) => get(priceTypeAtom) || (localStorage.getItem(TvPriceTypeStorageKey) as PriceTypes) || 'MID',
  (_get, set, newValue: PriceTypes) => {
    set(priceTypeAtom, newValue);
    localStorage.setItem(TvPriceTypeStorageKey, newValue);
  },
);
persistentPriceTypeAtom.debugLabel = 'persistentPriceTypeAtom';

export const PriceType = () => {
  const [priceType, setPriceType] = useAtom(persistentPriceTypeAtom);

  return (
    <Dropdown
      withClickClose
      trigger={
        <Button withChevron css={{ textStyle: 'Text/S/Regular', whiteSpace: 'nowrap' }}>
          {PriceTypeLabelMapper[priceType]}
        </Button>
      }
      css={{ minW: 140 }}
    >
      <div className={stack({ gap: 6 })}>
        {PriceTypes.map((pt) => (
          <CheckItem
            checked={pt.value === priceType}
            value={pt.value}
            key={pt.value}
            onClick={() => {
              setPriceType(pt.value);
            }}
          >
            {pt.label}
          </CheckItem>
        ))}
      </div>
    </Dropdown>
  );
};

type PriceTypes = 'MID' | 'MARK';

const PriceTypeLabelMapper: Record<PriceTypes, string> = {
  MID: 'Mid price',
  MARK: 'Mark price',
};

const PriceTypes = Object.entries(PriceTypeLabelMapper).map(
  ([value, label]) => ({ label, value }) as { label: string; value: PriceTypes },
);
